import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42f23cc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-group list-group-flush w-100" }
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id", "onClick"]
const _hoisted_6 = ["id"]
const _hoisted_7 = ["id"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon bi-pen-fill text-primary" }, " edit  ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon bi-trash-fill text-danger" }, " delete  ", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "list-group-item text-primary",
        key: item.id,
        id: item.id
      }, [
        _createElementVNode("span", {
          class: "py-3",
          id: `title-${item.id}`
        }, _toDisplayString(item.title), 9, _hoisted_3),
        _createElementVNode("span", {
          id: `status-${item.id}`,
          class: "fst-italic"
        }, "Last updated: " + _toDisplayString(item.date), 9, _hoisted_4),
        _createElementVNode("span", {
          id: `feature-${item.id}`,
          onClick: ($event: any) => (_ctx.display(item.id)),
          class: "d-flex justify-content-evenly h-100 align-items-center"
        }, [
          _createElementVNode("i", {
            id: `icon-${item.id}`,
            class: "icon bi-gear"
          }, "  ", 8, _hoisted_6),
          _createElementVNode("div", {
            id: `more-${item.id}`,
            class: "features"
          }, _hoisted_10, 8, _hoisted_7)
        ], 8, _hoisted_5)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}